import { api } from "./api";

export const getHomeAnuncios = async (numeroPagina: string, ordem: string) => {
  try {
    const response = await api.get(`home/buscartodos/${numeroPagina}/${ordem}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getHomeDestaques = async () => {
  try {
    const response = await api.get(`home/buscardestaques`);
    return response.data
  }
  catch (error) {
    console.error(error);
  }
}

export const postFiltrarAnunciosHome = async (numeroPagina: string, ordem: string, corpo: any) => {
  try {
    const response = await api.post(`home/filtrar/${numeroPagina}/${ordem}`, 
      corpo
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}


export const getCategoriasHome = async (numeroPagina: string) => {
  try {
    const response = await api.get(`Categoria/buscartodos/${numeroPagina}`);
    return response.data;    
  } catch (error) {
    console.error(error);
  }
};

